import * as React from "react";
import { Link, Outlet } from "react-router-dom";
import { Authorization, GlobalAuthorization } from "../misc/components/Authorization";
import { PermissionEnum } from "../misc/api/ApiPermissionEnum";
import { useSecurityContext } from "../Core/SecurityContext";
import { MainState } from "../Core/reducers";
import { connect } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBell, faCalculator, faCommentDots, faDatabase, faFile, faGraduationCap, faHome, faPhone, faTableList, faTablet, faUserPlus, faUsers } from "@fortawesome/free-solid-svg-icons";

declare const rootUrl;

export interface AdminMenuLayoutProps {
    currentStudyId: string;
}

export const AdminMenuLayout = ({ currentStudyId }: AdminMenuLayoutProps) => {
    const { currentUserPermissions } = useSecurityContext();

    let userRoleManagement = [PermissionEnum.ViewRoleManagement, PermissionEnum.ViewUsers, PermissionEnum.ViewRoleManagement, PermissionEnum.EditUsers, PermissionEnum.CreateUsers];
    let coreStudyAdmin = [PermissionEnum.ViewStudies, PermissionEnum.ViewSites, PermissionEnum.ViewNotificationSubscriptions, PermissionEnum.ManageCustomCalculations, PermissionEnum.EditStudy, PermissionEnum.CreateStudy, PermissionEnum.CreateSite, PermissionEnum.EditSite, PermissionEnum.CreateNotificationSubscription, PermissionEnum.EditNotificationSubscription];
    let overreadingAdmin = [PermissionEnum.ViewFixedComments, PermissionEnum.CreateFixedComment, PermissionEnum.EditFixedComment];
    let deviceManagement = [PermissionEnum.ViewDevices, PermissionEnum.ViewDeviceResources, PermissionEnum.CreateDeviceResources, PermissionEnum.EditDeviceResources, PermissionEnum.ViewEDiaryConfigurations, PermissionEnum.CreateEDiaryConfiguration, PermissionEnum.EditEDiaryConfiguration, PermissionEnum.DeleteEDiaryConfiguration];

    return (
        <GlobalAuthorization currentPermissions={currentUserPermissions} permissionId={PermissionEnum.AccessAdmin}>
            <div className="row">
                <div className="col-sm-2 hidden-xs no-gutter">
                    <nav className="sidebar-nav">
                        <div className="sidebar-collapse">
                            <ul className="nav">
                                <Authorization currentPermissions={currentUserPermissions} studyId={currentStudyId} permissionIdsAny={userRoleManagement}>
                                    <li className="active">
                                        <span>User &amp; Role Management</span>
                                        <ul aria-expanded="false">
                                            <GlobalAuthorization currentPermissions={currentUserPermissions} permissionId={PermissionEnum.ViewUserManagement}>
                                                <li>
                                                    <Link id="requestsLink" to="/requests"><FontAwesomeIcon icon={faUserPlus} size="lg" />&nbsp;Users Access Requests</Link>
                                                </li>
                                            </GlobalAuthorization>
                                            <Authorization currentPermissions={currentUserPermissions} studyId={currentStudyId} permissionIdsAny={[PermissionEnum.ViewUserManagement, PermissionEnum.ViewUsers, PermissionEnum.EditUsers, PermissionEnum.CreateUsers]}>
                                                <li>
                                                    <Link id="usersLink" to="/users"><FontAwesomeIcon icon={faUsers} size="lg" />&nbsp;Users</Link>
                                                </li>
                                            </Authorization>
                                            <Authorization currentPermissions={currentUserPermissions} studyId={currentStudyId} permissionId={PermissionEnum.ViewRoleManagement}>
                                                <li>
                                                    <Link to="/rolemanagement" id="rolesLink"><FontAwesomeIcon icon={faGraduationCap} size="lg" />&nbsp;Roles</Link>
                                                </li>
                                            </Authorization>
                                        </ul>
                                    </li>
                                </Authorization>
                                <Authorization currentPermissions={currentUserPermissions} studyId={currentStudyId} permissionIdsAny={coreStudyAdmin}>
                                    <li className="active">
                                        <span>Core Study Administration</span>
                                        <ul aria-expanded="false">
                                            <GlobalAuthorization currentPermissions={currentUserPermissions} permissionIdsAny={[PermissionEnum.ViewStudies, PermissionEnum.CreateStudy, PermissionEnum.EditStudy]}>
                                                <li><Link id="studiesLink" to="/studies"><FontAwesomeIcon icon={faTableList} size="lg" />&nbsp;Studies</Link></li>
                                            </GlobalAuthorization>
                                            <Authorization currentPermissions={currentUserPermissions} studyId={currentStudyId} permissionIdsAny={[PermissionEnum.ViewSites, PermissionEnum.CreateSite, PermissionEnum.EditSite]}>
                                                <li>
                                                    <Link id="sitesLink" to="/Sites"><FontAwesomeIcon icon={faHome} size="lg" />&nbsp;Sites</Link>
                                                </li>
                                            </Authorization>
                                            {currentStudyId ? <><Authorization studyId={currentStudyId} currentPermissions={currentUserPermissions} permissionIdsAny={[PermissionEnum.ViewNotificationSubscriptions, PermissionEnum.CreateNotificationSubscription, PermissionEnum.EditNotificationSubscription]}>
                                                <li>
                                                    <Link to="/admin/notifications" id="notificationsLink">
                                                        <FontAwesomeIcon icon={faBell} size="lg" />&nbsp;
                                                        Notifications
                                                    </Link>
                                                </li>
                                            </Authorization>
                                            <Authorization studyId={currentStudyId} currentPermissions={currentUserPermissions} permissionId={PermissionEnum.ManageCustomCalculations}>
                                                <li>
                                                    <Link to="/admin/customcalculations" id="notificationsLink">
                                                        <FontAwesomeIcon icon={faCalculator} size="lg" />&nbsp;
                                                        Custom Calculations
                                                    </Link>
                                                </li>
                                          </Authorization></> : null}
                                        </ul>
                                    </li>
                                </Authorization>
                                {currentStudyId ?
                                <Authorization currentPermissions={currentUserPermissions} studyId={currentStudyId} permissionIdsAny={overreadingAdmin}>
                                    <li className="active">
                                    <span>Overreading Administration</span>
                                    <ul aria-expanded="false">
                                        <Authorization currentPermissions={currentUserPermissions} studyId={currentStudyId} permissionIdsAny={[PermissionEnum.ViewFixedComments, PermissionEnum.CreateFixedComment, PermissionEnum.EditFixedComment]}>
                                        <li>
                                            <Link id="fixedCommentsLink" to="/FixedComments"><FontAwesomeIcon icon={faCommentDots} size="lg" />&nbsp;Fixed Comments Management</Link>
                                        </li>
                                        </Authorization>
                                    </ul>
                                    </li>
                                </Authorization> : null}
                                <Authorization currentPermissions={currentUserPermissions} studyId={currentStudyId} permissionIdsAny={deviceManagement}>
                                    <li className="active">
                                        <span>Device Management</span>
                                        <ul>
                                            <Authorization currentPermissions={currentUserPermissions} studyId={currentStudyId} permissionId={PermissionEnum.ViewDevices}>
                                                <li>
                                                    <Link id="deviceAdministrationLink" to="/deviceadministration"><FontAwesomeIcon icon={faTablet} size="lg" />&nbsp;Device Administration</Link>
                                                </li>
                                            </Authorization>
                                            <Authorization currentPermissions={currentUserPermissions} studyId={currentStudyId} permissionIdsAny={[PermissionEnum.ViewDeviceResources, PermissionEnum.CreateDeviceResources, PermissionEnum.EditDeviceResources]}>
                                                <li>
                                                    <Link to="/UpdatePackages" id="updatePackagesLink">
                                                        <FontAwesomeIcon icon={faDatabase} size="lg" />&nbsp;Packages
                                                    </Link>
                                                </li>
                                                <li>
                                                    <Link to="/serviceresources" id="serviceResourceLink">
                                                        <FontAwesomeIcon icon={faDatabase} size="lg" />&nbsp;Services Resources
                                                    </Link>
                                                </li>
                                            </Authorization>
                                            <Authorization currentPermissions={currentUserPermissions} studyId={currentStudyId} permissionIdsAny={[PermissionEnum.ViewEDiaryConfigurations, PermissionEnum.CreateEDiaryConfiguration, PermissionEnum.EditEDiaryConfiguration, PermissionEnum.DeleteEDiaryConfiguration]}>
                                                <li>
                                                    <Link to="/DiaryConfigurations" id="eDiaryConfigurationsLink">
                                                        <FontAwesomeIcon icon={faTablet} size="lg" />&nbsp;Diary Configurations
                                                    </Link>
                                                </li>
                                            </Authorization>
                                        </ul>
                                    </li>
                                </Authorization>
                              {currentStudyId ? <Authorization currentPermissions={currentUserPermissions} studyId={currentStudyId} permissionId={PermissionEnum.EditSupportContactInformationAdministration}>
                                <li className="active">
                                  <span>Technical Support Management</span>
                                  <ul aria-expanded="false">
                                    <li>
                                      <Link to="/admin/editcontact" id="supportContactLink">
                                        <FontAwesomeIcon icon={faPhone} size="lg" />&nbsp;
                                        Support Contact Information
                                      </Link>
                                    </li>
                                  </ul>
                                </li>
                              </Authorization> : null}
                                <Authorization currentPermissions={currentUserPermissions} studyId={currentStudyId} permissionId={PermissionEnum.AccessHangfire}>
                                    <li className="active">
                                        <span>Job Management</span>
                                        <ul aria-expanded="false">
                                            <li>
                                                <a href="/hangfire" id="hangfireJobsLink">
                                                    <FontAwesomeIcon icon={faTableList} size="lg" />&nbsp;
                                                    Hangfire Jobs
                                                </a>
                                            </li>
                                        </ul>
                                    </li>
                                </Authorization>
                                <Authorization currentPermissions={currentUserPermissions} studyId={currentStudyId} permissionId={PermissionEnum.ViewAuditTrail}>
                                    <li className="active">
                                        <span>Audit</span>
                                        <ul aria-expanded="false">
                                            <li>
                                                <Link to="/Audit" id="auditTrailLink">
                                                    <FontAwesomeIcon icon={faFile} size="lg" />&nbsp;
                                                    Audit Trail
                                                </Link>
                                            </li>
                                        </ul>
                                    </li>
                                </Authorization>
                            </ul>
                        </div>
                    </nav>
                </div>
                <div className="col-sm-10">
                    <Outlet />
                </div>
            </div>
        </GlobalAuthorization>
    );
}

function mapStateToProps(state: MainState): AdminMenuLayoutProps {
    return {
        currentStudyId: state.security.studyId
    };
}

export default connect<AdminMenuLayoutProps, any, {}>(mapStateToProps)(
    AdminMenuLayout
);

